import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
    total: 0,
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getTotal(state) {
      return state.total;
    },
  },
  mutations: {
    setData(state, payload) {
      state.items = payload.items || [];
      state.total = payload.total || 0;
    },
    updateLocalStatus(state, { id, status }) {
      const item = state.items.find((currentItem) => currentItem.id === id);
      if (!item) return;
      if ("status_name" in item) item.status_name = status;
      if ("status" in item) item.status = status;
      if (item.last_status && typeof item.last_status === "object") {
        item.last_status.name = status;
      }
    },
  },
  actions: {
    async fetchBauComplements({ commit }, params) {
      const response = await axios.get("/v1/bau-complements", { params });
      const { data, total, meta } = response.data;
      commit("setData", {
        items: data || [],
        total: meta?.total || total || 0,
      });
      return response.data;
    },
    updateLocalStatus({ commit }, payload) {
      commit("updateLocalStatus", payload);
    },
    async deleteBauComplement(_, bauComplementId) {
      const { data } = await axios.delete(`/v1/bau-complements/${bauComplementId}`);
      return data;
    },
    async updateBauComplementStatus(_, { bauComplementId, statusName }) {
      const { data } = await axios.post(`/v1/bau-complements/update_status/${bauComplementId}`, {
        status: statusName,
      });
      return data;
    },
    async createBauComplement(_, payload) {
      const { data } = await axios.post("/v1/bau-complements", payload);
      return data;
    },
    async updateBauComplement(_, { bauComplementId, payload }) {
      const { data } = await axios.put(`/v1/bau-complements/${bauComplementId}`, payload);
      return data;
    },
    async fetchBauComplement(_, bauComplementId) {
      const { data } = await axios.get(`/v1/bau-complements/${bauComplementId}`);
      return data;
    },
    async fetchReviewers(_, params) {
      const { data } = await axios.get("/v1/bau-complements/getReviewers", { params });
      return data;
    },
    async fetchReassignable(_, params) {
      const { data } = await axios.get("/v1/bau-complements/getReassignable", { params });
      return data;
    },
  },
};
